
<app-card-view-layout (onAdd)="onAddNewSystem()" [actionButtons]="actionButtons"  [showEdit]="true" [showAdd]="auth.isSuperAdmin(this.auth.user$ | async)"   [data]="systems$" (onDelete)="onDeleteSystem($event)" (onUpdate)="onUpdateSystem( $event)">

  <!-- <app-card-view-simple-card *ngFor="let system of systems$ | async; let i = index" [title]="system.name" [defaultLink]="system.url"
    [actionButtons]="actionButtons" [showDelete]="auth.canEdit(this.auth.user$ | async)" (onDelete)="onDeleteSystem($event)" (onUpdate)="onUpdateSystem( $event)">

  </app-card-view-simple-card> -->

</app-card-view-layout>

